
import React, { useEffect, useState, Fragment } from "react";
import { useSelector, useDispatch } from 'react-redux';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';

import { LoadingComponent } from 'recupero-comunes'
import 'recupero-comunes/dist/index.css'
import { Card, Container } from "react-bootstrap";
import { obtenerConsultaCasos } from "../../store/actions/area-busqueda-casos-informes-action";
import { useNavigate } from 'react-router-dom'
import AtenderInformeProfesional from "../atender-informe-profesional";
import { VerInformeProfesionalComponent } from 'defcol-caso-general';

const BandejaCasos = () => {

    const history = useNavigate()
    const data_encargado = useSelector((state) => state.gestionDefensaReducer)
    const {llaves} = data_encargado

    const data_areaBuscar = useSelector((state) => state.areaBusquedaCasosInformesReducer)
    const {cfg_form92, consultaCasos, excel, myQueryStateGlobal} = data_areaBuscar
    const [loading, setLoading] = useState(false);
    const [listaGrilla, setListaGrilla] = useState('');

    const [showAtenderInformeProfesional, setShowAtenderInformeProfesional] = useState(false)
    const [rowSelected, setRowSelected] = useState(false)

    // ver Informe Profesional
    const [showVerInformeProfesional, setShowVerInformeProfesional] = useState(false)

    const dispatch = useDispatch();
    useEffect(()=>{
        setListaGrilla(consultaCasos && consultaCasos.consultaCasos)
    },[consultaCasos])
    
    const handleReload = () => {

        if (consultaCasos && consultaCasos.query) {

            setLoading(true);

            // Obtener última query enviada
            let query = consultaCasos.query;

            // Ejecutar acción para obtener casos.
            dispatch(obtenerConsultaCasos(query)).then(() => {
                setLoading(false);
            });
        }
    }

    const onClick = (row) => {
        setRowSelected(row);       
        setShowAtenderInformeProfesional(true);
    };
    const verInformeModoConsulta = (row) => {
        setRowSelected(row);      
        setShowVerInformeProfesional(true);
    }
    const obtenerColumnas = () => {

        return [
            { 
                dataField: 'IdCaso', text: cfg_form92 ? cfg_form92.cfg_form92['busqueda-caso-informes-grilla-id']:'', sort: true, headerAlign: 'center', align: 'center',
                headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>)
            },
           
            { 
                dataField: 'Siniestro', text: cfg_form92 ? cfg_form92.cfg_form92['busqueda-caso-informes-grilla-sini']:'', sort: true, headerAlign: 'center', align: 'center',
                headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>)
            },
            { 
                dataField: 'PatenteAsegurado', text: cfg_form92 ? cfg_form92.cfg_form92['busqueda-caso-informes-grilla-placa']:'', sort: true, headerAlign: 'center', align: 'center',
                headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>)
            },
            {
                dataField: 'TipoInforme', text:cfg_form92 ? cfg_form92.cfg_form92['busqueda-caso-informes-grilla-tipinf']:'', headerAlign: 'center', align: 'center'
                ,headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>)
            },
            { 
                dataField: 'FechaAsignacion', text: cfg_form92 ? cfg_form92.cfg_form92['busqueda-caso-informes-grilla-fechasig']:'', 
                sort: true, 
                sortFunc: (a, b, order, dataField, rowA, rowB) => {
                    if (order === 'asc') return stringDate2Time(a) - stringDate2Time(b);
                    else return stringDate2Time(b) - stringDate2Time(a);
                }, 
                headerAlign: 'center', align: 'center',
                headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>)
            },
            { 
                dataField: 'Implicado', text: cfg_form92 ? cfg_form92.cfg_form92['busqueda-caso-informes-grilla-implicado']:'', sort: true, headerAlign: 'center', align: 'center',
                headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>)
            },
            { 
                dataField: 'EstadoCaso', text: cfg_form92 ? cfg_form92.cfg_form92['busqueda-caso-informes-grilla-estado']:'', sort: true, headerAlign: 'center', align: 'center',
                headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>)
            },
            { 
                dataField: 'FechaEmision', text: cfg_form92 ? cfg_form92.cfg_form92['busqueda-caso-informes-grilla-fechaemi']:'', 
                sort: true, 
                sortFunc: (a, b, order, dataField, rowA, rowB) => {
                    if (order === 'asc') return stringDate2Time(a) - stringDate2Time(b);
                    else return stringDate2Time(b) - stringDate2Time(a);
                }, 
                headerAlign: 'center', align: 'center',
                headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>)
            }, 
            { 
                dataField: 'FechaAudiencia', text: cfg_form92 ? cfg_form92.cfg_form92['busqueda-caso-informes-grilla-fechaud']:'', 
                sort: true, 
                sortFunc: (a, b, order, dataField, rowA, rowB) => {
                    if (order === 'asc') return stringDate2Time(a) - stringDate2Time(b);
                    else return stringDate2Time(b) - stringDate2Time(a);
                }, 
                headerAlign: 'center', align: 'center',
                headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>)
            },                 
            {
                dataField: 'accion', text:cfg_form92 ? cfg_form92.cfg_form92['busqueda-caso-informes-grilla-accion']:'' , isDummyField: true,  headerAlign: 'center', align: 'center' ,
                
                formatter: (cell, row) => (
                    <div>
                        {((row.EstadoTarea === 28001 || row.EstadoTarea === 28003) && row.codEstadoSolicitud != 300004) ? (
                            <Button type="button" variant="subir me-md-2" size="sm" onClick={ () => onClick(row) }>
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
                                    <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.354 3.793l-2.147-2.147 1.148-1.147a.5.5 0 0 1 .707 0l1.44 1.44zm-1.75 2.456l-2.147-2.147L5.5 8.354V10.5h2.146l6.106-6.106z"/>
                                    <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5h6a.5.5 0 0 0 0-1h-6A1.5 1.5 0 0 0 1 2.5v11z"/>
                                </svg>
                            </Button>
                        ) : (
                            <Button type="button" variant="subir me-md-2" size="sm" onClick={ () => verInformeModoConsulta(row) }>
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-search" viewBox="0 0 16 16">
                                    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
                                </svg>
                            </Button>
                        )}
                    </div>                                       
                )
                , headerStyle:{verticalAlign: 'middle'}
            }
        ];
    }

    const stringDate2Time = (date) => {
        date = date.split("-");
        return new Date( date[2], date[1] - 1, date[0]).getTime();
    }

    return (
        <>
            <AtenderInformeProfesional
                idCaso={rowSelected?.IdCaso}
                idOrgCaso={rowSelected?.IdOrgCaso}
                idSolicitud={rowSelected?.IdSolicitud}
                idTrxOrigen={rowSelected?.IdTrxOrigen}
                showModal={showAtenderInformeProfesional}
                setShowModal={setShowAtenderInformeProfesional}
                handleReload={handleReload}
            />
            <VerInformeProfesionalComponent
                idCaso={rowSelected?.IdCaso}
                idSolicitud={rowSelected?.IdSolicitud}                
                showModal={showVerInformeProfesional}
                setShowModal={setShowVerInformeProfesional}
            />

        <div>
            <style type='text/css'>
        {`
    .btn-subir {
      background-color: #00aeab;
      color: #FFFFFF;   
      height:40px;

    }
    .btn-subir:hover{
        background-color:#01cec8;
        color: #FFFFFF;
        
    } 
    
    `}
    </style>
 
            <LoadingComponent show={loading} />
            { cfg_form92 ? 
            <Card >
                <Card.Header
                className='mt-0 mb-0'
                as='h6'
                style={{ backgroundColor: '#4F517A', color: 'white', textAlign:'center' }}
                >
                {cfg_form92
                    ? `${cfg_form92.cfg_form92['busqueda-caso-informes-resultado']} (${consultaCasos && consultaCasos.consultaCasos !==undefined ? consultaCasos.consultaCasos.length : 0})`
                    : ''} 
                </Card.Header>
            <ToolkitProvider search bootstrap4 keyField="Id" 
                data={ listaGrilla ? listaGrilla : [] } 
                columns={ obtenerColumnas() } defaultSorted={ [{ dataField: 'Id', order: 'asc' }] }>
                { 
                props =>                   
                    <div>
                        
                        <Row>
                            <Col md={4} className="d-grid gap-2 d-md-flex justify-content-md-start mt-2 mb-2">                                
                            </Col>                           
                            <Col md={8} className="d-grid gap-2 d-md-flex justify-content-md-end mt-2 mb-2">
                                
                                <Form.Control placeholder="Buscar en la grilla" className="w-25" onChange={(e) => { props.searchProps.onSearch(e.target.value) }}/>
                                <Button className="mx-2" type="button" variant="outline-info" size="sm" onClick={() => { handleReload() }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-clockwise" viewBox="0 0 16 16">
                                    <path fillRule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"/>
                                    <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"/>
                                    </svg>
                                </Button>
                               
                            </Col>                           
                        </Row>                        
                        <BootstrapTable { ...props.baseProps } headerWrapperClasses="table-secondary" pagination={ paginationFactory() } noDataIndication={<div className="text-center">No hay registros encontrados</div>} />
                    </div>
                }
            </ToolkitProvider>
            </Card>
     
            : null }
        </div>
        </>
    );
}

export default BandejaCasos;
